<div class="agenda" *ngIf="loaded">
    <div *ngIf="agenda.tabs && agenda.tabs.length > 1">
        <mat-tab-group>
            <mat-tab label="{{tab.name}}" *ngFor="let tab of agenda.tabs">
                <div class="agenda-entry" *ngFor="let entry of tab.entries">
                    <div class="date" [innerHtml]="entry.date | safeHTML"></div>
                    <div *ngIf="entry.link && !entry.linkExternal">
                        <a *ngIf="!entry.queryParam" routerLinkActive="active" [routerLink]="['/' + entry.link]" (click)="loadRoute(entry.link)">
                            <div class="topic active-hover" [innerHtml]="entry.topic | safeHTML"></div>
                        </a>
                        <a *ngIf="entry.queryParam" routerLinkActive="active" [routerLink]="['/' + entry.link]" [queryParams]="entry.queryParam"  (click)="loadRoute(entry.link)">
                            <div class="topic active-hover" [innerHtml]="entry.topic | safeHTML"></div>
                        </a>
                    </div>
                    <div *ngIf="entry.link && entry.linkExternal">
                        <a href="{{ entry.link }}" target="_blank">
                            <div class="topic active-hover" [innerHtml]="entry.topic | safeHTML"></div>
                        </a>
                    </div>
                    <div *ngIf="!entry.link">
                        <div class="topic" [innerHtml]="entry.topic | safeHTML"></div>
                    </div>
                    <div class="speakers">
                        <div class="speaker" *ngFor="let speaker of entry.speakers" [ngClass]="{'fullSpeaker' : entry.speakers.length == 1}">
                            <div class="profil-picture" *ngIf="speaker.image">
                                <img src="{{ speaker.image }}" />
                            </div>
                            <div class="bio">
                                <a href="{{ speaker.link }}" target="_blank" *ngIf="speaker.link">
                                    <p class="name active-hover" [innerHtml]="speaker.name | safeHTML"></p>
                                </a>
                                <p class="name" *ngIf="!speaker.link" [innerHtml]="speaker.name | safeHTML"></p>
                                <p [innerHtml]="speaker.bio | safeHTML"></p>
                            </div>
                        </div>
                    </div>
                    <div class="line"></div>
                </div>
            </mat-tab>
        </mat-tab-group>

    </div>

    <div *ngIf="agenda.tabs && agenda.tabs.length === 1">
        <div class="agenda-entry" *ngFor="let entry of agenda.tabs[0].entries">
            <div class="date" [innerHtml]="entry.date | safeHTML"></div>
            <div *ngIf="entry.link && !entry.linkExternal">
                <a *ngIf="!entry.queryParam" routerLinkActive="active" [routerLink]="['/' + entry.link]" (click)="loadRoute(entry.link)">
                    <div class="topic active-hover" [innerHtml]="entry.topic | safeHTML"></div>
                </a>
                <a *ngIf="entry.queryParam" routerLinkActive="active" [routerLink]="['/' + entry.link]" [queryParams]="entry.queryParam"  (click)="loadRoute(entry.link)">
                    <div class="topic active-hover" [innerHtml]="entry.topic | safeHTML"></div>
                </a>
            </div>
            <div *ngIf="entry.link && entry.linkExternal && !entry.queryParam">
                <a href="{{ entry.link }}" target="_blank">
                    <div class="topic active-hover" [innerHtml]="entry.topic | safeHTML"></div>
                </a>
            </div>
            <div *ngIf="!entry.link">
                <div class="topic" [innerHtml]="entry.topic | safeHTML"></div>
            </div>
            <div class="speakers">
                <div class="speaker" *ngFor="let speaker of entry.speakers">
                    <div class="profil-picture" *ngIf="speaker.image">
                        <img src="{{ speaker.image }}" />
                    </div>
                    <div class="bio">
                        <a href="{{ speaker.link }}" target="_blank" *ngIf="speaker.link">
                            <p class="name active-hover" [innerHtml]="speaker.name | safeHTML"></p>
                        </a>
                        <p class="name" *ngIf="!speaker.link" [innerHtml]="speaker.name | safeHTML"></p>
                        <p [innerHtml]="speaker.bio | safeHTML"></p>
                    </div>
                </div>
            </div>
            <div class="line"></div>
        </div>
    </div>
</div>
